import { useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import PromoDetails from './components/PromoDetails';
import HowItWorks from './components/HowItWorks';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <About />
      <PromoDetails />
      <HowItWorks />
      <FAQ />
      <CTA />
      <Footer />
    </div>
  );
}
